/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelModulePackagesParams,
  ModelModulePackage,
  ModelModulePackageInput,
  ModelModulePackages,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Module Package
 */
export const createModelModulePackage = (
    modelModulePackageInput: MaybeRefOrGetter<ModelModulePackageInput>,
 signal?: AbortSignal
) => {
      modelModulePackageInput = toValue(modelModulePackageInput);

      return axiosClient<ModelModulePackage>(
      {url: `/model-module-packages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelModulePackageInput, signal
    },
      );
    }




export const getCreateModelModulePackageMutationKey = () => ['createModelModulePackage'] as const;

export const getCreateModelModulePackageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelModulePackage>>, TError,CreateModelModulePackageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelModulePackage>>, TError,CreateModelModulePackageMutationVariables, TContext> => {

const mutationKey = getCreateModelModulePackageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelModulePackage>>, CreateModelModulePackageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModelModulePackage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelModulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof createModelModulePackage>>>
    export type CreateModelModulePackageMutationBody = ModelModulePackageInput
    export type CreateModelModulePackageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateModelModulePackageMutationVariables = {data: ModelModulePackageInput}

    /**
 * @summary Create Model Module Package
 */
export const useCreateModelModulePackage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelModulePackage>>, TError,CreateModelModulePackageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelModulePackage>>,
        TError,
        CreateModelModulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelModulePackageMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Module Packages list
 */
export const listModelModulePackages = (
    params?: MaybeRefOrGetter<ListModelModulePackagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelModulePackages>(
      {url: `/model-module-packages`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelModulePackagesQueryKey = (params?: MaybeRefOrGetter<ListModelModulePackagesParams>,) => {
    return [
    'model-module-packages', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelModulePackagesQueryOptions = <TData = Awaited<ReturnType<typeof listModelModulePackages>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelModulePackagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelModulePackages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelModulePackagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelModulePackages>>> = ({ signal }) => listModelModulePackages(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelModulePackages>>, TError, TData>
}

export type ListModelModulePackagesQueryResult = NonNullable<Awaited<ReturnType<typeof listModelModulePackages>>>
export type ListModelModulePackagesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Module Packages list
 */

export function useListModelModulePackages<TData = Awaited<ReturnType<typeof listModelModulePackages>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelModulePackagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelModulePackages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelModulePackagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Module Package
 */
export const destroyModelModulePackage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-module-packages/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelModulePackageMutationKey = () => ['destroyModelModulePackage'] as const;

export const getDestroyModelModulePackageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelModulePackage>>, TError,DestroyModelModulePackageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelModulePackage>>, TError,DestroyModelModulePackageMutationVariables, TContext> => {

const mutationKey = getDestroyModelModulePackageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelModulePackage>>, DestroyModelModulePackageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModelModulePackage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelModulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelModulePackage>>>

    export type DestroyModelModulePackageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelModulePackageMutationVariables = {id: string}

    /**
 * @summary Destroy Model Module Package
 */
export const useDestroyModelModulePackage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelModulePackage>>, TError,DestroyModelModulePackageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelModulePackage>>,
        TError,
        DestroyModelModulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelModulePackageMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Module Package Detail
 */
export const modelModulePackage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelModulePackage>(
      {url: `/model-module-packages/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelModulePackageQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-module-packages',id
    ] as const;
    }


export const getModelModulePackageQueryOptions = <TData = Awaited<ReturnType<typeof modelModulePackage>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModulePackage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelModulePackageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelModulePackage>>> = ({ signal }) => modelModulePackage(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelModulePackage>>, TError, TData>
}

export type ModelModulePackageQueryResult = NonNullable<Awaited<ReturnType<typeof modelModulePackage>>>
export type ModelModulePackageQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Module Package Detail
 */

export function useModelModulePackage<TData = Awaited<ReturnType<typeof modelModulePackage>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelModulePackage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelModulePackageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Module Package
 */
export const updateModelModulePackage = (
    id: MaybeRefOrGetter<string>,
    modelModulePackageInput: MaybeRefOrGetter<ModelModulePackageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelModulePackageInput = toValue(modelModulePackageInput);

      return axiosClient<ModelModulePackage>(
      {url: `/model-module-packages/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelModulePackageInput, signal
    },
      );
    }




export const getUpdateModelModulePackageMutationKey = () => ['updateModelModulePackage'] as const;

export const getUpdateModelModulePackageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelModulePackage>>, TError,UpdateModelModulePackageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelModulePackage>>, TError,UpdateModelModulePackageMutationVariables, TContext> => {

const mutationKey = getUpdateModelModulePackageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelModulePackage>>, UpdateModelModulePackageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelModulePackage(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelModulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelModulePackage>>>
    export type UpdateModelModulePackageMutationBody = ModelModulePackageInput
    export type UpdateModelModulePackageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelModulePackageMutationVariables = {id: string;data: ModelModulePackageInput}

    /**
 * @summary Update Model Module Package
 */
export const useUpdateModelModulePackage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelModulePackage>>, TError,UpdateModelModulePackageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelModulePackage>>,
        TError,
        UpdateModelModulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelModulePackageMutationOptions(options), queryClient);
    }
